import { lazy } from 'react';

export const SchedulePage = lazy(() => import('./SchedulePage'));
